import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class SigningLogsService {
    // Use Laravel basePath (same as other API calls)
    private basePath = environment.interop.basePath;
    private logsBasePath = environment.interop.indoc.nomenclatoare.administrative.signer;

    constructor(private http: HttpClient) {}

    getSigningLogs(params: any): Observable<any> {
        const url = `${this.basePath}${this.logsBasePath.logs?.signing || 'api/registratura/signer/logs/signing'}`;
        return this.http.get<any>(url, {
            params: this.buildParams(params)
        });
    }

    getSigningLogDetail(logId: number): Observable<any> {
        const detailPath = this.logsBasePath.logs?.signingDetail || 'api/registratura/signer/logs/signing/';
        const url = `${this.basePath}${detailPath}${logId}`;
        return this.http.get<any>(url);
    }

    getStatuses(): Observable<any> {
        const url = `${this.basePath}${this.logsBasePath.logs?.signingStatuses || 'api/registratura/signer/logs/meta/statuses'}`;
        return this.http.get<any>(url);
    }

    exportCsv(params: any): Observable<Blob> {
        const url = `${this.basePath}${this.logsBasePath.logs?.signingExport || 'api/registratura/signer/logs/signing/export/csv'}`;
        return this.http.get(url, {
            params: this.buildParams(params),
            responseType: 'blob'
        });
    }

    downloadSignedFile(requestId: string): Observable<Blob> {
        const url = `${this.basePath}api/registratura/signer/download-file/${requestId}`;
        return this.http.get(url, {
            responseType: 'blob'
        });
    }

    private buildParams(params: any): HttpParams {
        let httpParams = new HttpParams();
        Object.keys(params).forEach(key => {
            if (params[key] !== null && params[key] !== undefined && params[key] !== '') {
                httpParams = httpParams.set(key, params[key]);
            }
        });
        return httpParams;
    }
}
